import style from './SuggestItem.module.css'

const SuggestItem = ({ children }) => {
  return (
    <div className={style.item}>{children}</div>
  )
}

export default SuggestItem
